<section class="py-5">
  <div class="container py-md-5">
    <div class="row gx-5">

      <div class="d-flex col-12 col-md-6 align-items-center">
        <div class="">
          <img src="assets/images/adobe/campus_logo.svg"
               alt="Adobe Creative Campus"
               class="img-fluid"
          >
          <p class="fs-5 fw-bold mt-4">
            As an Adobe Creative Campus, we are part of a select group of colleges
            and universities that have empowered students in all disciplines
            with essential digital skills to succeed in the classroom and beyond.
            With full access to Adobe creativity tools,
            students learn to communicate more effectively,
            build their personal brands,
            prepare for the challenges of an increasingly digital world,
            and prepare to achieve their goals as students
            on campus and after graduation.
          </p>
        </div>
      </div>

      <div class="d-none col-md-1 d-xl-block"></div>

      <div class="col-12 col-md-6 col-xl-5 d-flex justify-content-start justify-content-md-end">
        <div>
          <img ngSrc="assets/images/adobe/stock-1.jpg"
               alt="one student watches another student draw on a tablet in a computer lab"
               class="img-fluid"
               height="560" width="440">
        </div>
      </div>

    </div>
  </div>
</section>
